/**
 *  @name dialog_mixins
 *  @author liubo
 *  @description dialog组件统一配置
 *   <el-dialog title="" :visible.sync="dialogVisible" :close-on-click-modal="closeModal" :close-on-press-escape="closeEscape" :before-close="cancel"></el-dialog>
 *   import
 *   <xxx-xxx v-if="data" :data="data" @cancel="data=''" @close="data='';refresh()"></xxx-xxx>
 */
export default{
  data(){
    return {
      // 是否显示
      dialogVisible: true,
      // Dialog CSS 中的 margin-top 值,默认15vh
      top: '15vh',
      // 是否可以通过点击 modal 关闭 Dialog
      closeModal: false,
      // 是否可以通过按下 ESC 关闭 Dialog
      closeEscape: false     
    }
  },
  methods: {
    // 关闭dialog , 需要刷新列表, 列表有删除操作，使用search() 无删除操作使用refresh()
    close (data) {
      this.$emit('close',data)
    },
    // 关闭dialog, 不需要刷新列表
    cancel () {
      this.$emit('cancel')
    }
  },
}